<template>
  <div class="home">
    <div class="contact-btn-ctn">
      <btn @click="$store.dispatch($SET_TOGGLE_CONTACT_MODAL_OPEN)">
        <span class="contact-btn">
          Contato
        </span>
      </btn>
    </div>
    <div
      ref="container"
      class="preview-ctn"
      :class="`preview-ctn--${selectedPreview}`"
    >
      <preview name="Dry Signals"
               type="Universidade de Illinois"
               project-type="external"
               external-url="https://sensatejournal.com/dry-signals/"
               :invisible="selectedPreview !== 1"
      >
        <div class="logo-ctn dry-signals-ctn" />
      </preview>
      <preview name="Onesti"
               type="Site institucional"
               project-type="external"
               external-url="https://www.onestiadvogados.com.br"
               :invisible="selectedPreview !== 2"
      >
        <div class="logo-ctn onesti-logo-ctn">
          <img src="@/assets/onesti-advogados.svg" alt="">
        </div>
      </preview>
      <preview name="Paguru"
               type="Logotipo"
               project-type="behance"
               external-url="https://www.behance.net/gallery/58358673/Paguru-logo-design"
               :invisible="selectedPreview !== 3"
      >
        <div class="logo-ctn paguru-logo-ctn">
          <img src="@/assets/paguru.svg" alt="">
        </div>
      </preview>
      <preview name="Dnare"
               type="Logotipo"
               project-type="presentation"
               :invisible="selectedPreview !== 4"
      >
        <div class="logo-ctn dnare-logo-ctn">
          <img src="@/assets/dnare/dnare.svg" alt="">
        </div>
      </preview>
      <preview name="Lenossa"
               type="Identidade Visual"
               project-type="presentation"
               :invisible="selectedPreview !== 5"
      >
        <div class="logo-ctn lenossa-logo-ctn">
          <img src="../assets/lenossa/lenossa-logo.svg" alt="">
        </div>
        <!--        <lenossa-fluid-pieces v-if="isComponentMounted" :is-showing="selectedPreview === 3" />-->
      </preview>
      <preview name="V. Linard"
               type="Identidade Visual"
               project-type="behance"
               external-url="https://www.behance.net/gallery/69693791/Victor-Linard"
               :invisible="selectedPreview !== 6"
      >
        <div class="logo-ctn victor-linard-logo-ctn">
          <img src="@/assets/victor-linard.svg" alt="">
        </div>
      </preview>
    </div>
    <btn class="control control--previous"
         :class="selectedPreview === 1 ? `control--previous-hidden` : undefined"
         @click="decreasePreviewIndex"
    >
      <span class="control__icon">
        <i class="fas fa-arrow-left" />
      </span>
    </btn>
    <btn class="control control--next"
         :class="selectedPreview === previewBackgroundTexts.length ? `control--next-hidden` : undefined"
         @click="increasePreviewIndex"
    >
      <span class="control__icon">
        <i class="fas fa-arrow-right" />
      </span>
    </btn>
    <background
      :selected-preview="selectedPreview - 1"
      :background-texts="previewBackgroundTexts"
    />
  </div>
</template>

<script>
import '@/assets/styles/tailwind.sass'
import Preview from '@/components/preview'
import { Power4, TweenMax } from 'gsap'
import Background from '@/components/background'
import { mapState } from 'vuex'
import Hammer from 'hammerjs'

export default {
  name: 'Home',
  components: {
    Background,
    Preview
  },
  data () {
    return {
      previousSelectedPreview: 0,
      previewList: [],
      isComponentMounted: false,
      selectedProject: undefined,
      lastDirection: 'right',
      isMenuVisible: false,
      previewChangeCount: 0
    }
  },
  computed: {
    ...mapState(['previewBackgroundTexts', 'isMobile', 'didSeeDragTooltip']),
    selectedPreview () {
      return this.$store.state.currentPreviewIndex
    }
  },
  methods: {
    decreasePreviewIndex () {
      if (this.selectedPreview !== 1) {
        this.previewChangeCount += 1
        this.$store.dispatch(this.$SET_CURRENT_PREVIEW, [this.selectedPreview - 1, 'left'])
      }
    },
    increasePreviewIndex () {
      if (this.selectedPreview !== this.previewBackgroundTexts.length) {
        this.previewChangeCount += 1
        this.$store.dispatch(this.$SET_CURRENT_PREVIEW, [this.selectedPreview + 1, 'right'])
      }
    },
    openProject (prj) {
      TweenMax.to(`.overlay--${prj}`, 0.8, {
        scaleY: 1,
        ease: Power4.easeOut,
        onComplete: () => {
          this.$router.push({ name: prj })
        } })
    }
  },
  watch: {
    previewChangeCount (val) {
      const PROJECTS_TO_SEE_BEFORE_TOOLTIP = 2
      if (val === PROJECTS_TO_SEE_BEFORE_TOOLTIP && this.isMobile && !this.didSeeDragTooltip) {
        const tooltipTime = 8000
        this.$root.$emit('show-tooltip', {
          icon: 'drag',
          title: 'Arraste para navegar!',
          text: 'Você também pode deslizar o dedo pela tela para navegar.',
          time: tooltipTime
        })
      }
    }
  },
  created () {
    this.$store.dispatch(this.$CHANGE_CURSOR_STATE, 'default')
  },
  mounted () {
    if (this.isMobile) {
      const previewContainer = this.$refs.container
      const hammer = new Hammer(previewContainer)
      hammer.on('swipeleft', () => {
        this.increasePreviewIndex()
        this.$store.dispatch(this.$SET_DID_SEE_DRAG_TOOLTIP)
      })
      hammer.on('swiperight', () => {
        this.decreasePreviewIndex()
        this.$store.dispatch(this.$SET_DID_SEE_DRAG_TOOLTIP)
      })
      this.$root.$on('dismiss-tooltip', () => {
        this.$store.dispatch(this.$SET_DID_SEE_DRAG_TOOLTIP)
      })
    }
    this.$root.$on('next-project', () => { this.increasePreviewIndex() })
    this.$root.$on('previous-project', () => { this.decreasePreviewIndex() })
    this.$emit('portfolio-loaded')
    this.isComponentMounted = true
    this.$children.forEach(child => {
      if (child.$el.classList.contains('preview')) this.previewList.push(child)
    })
  },
  comments: true
}
</script>
<style scoped lang="sass">
  @tailwind utilities

  /* purgecss start ignore */
  .home
    user-select: none

  .preview-ctn
    @apply fixed z-10 pin-t pin-l flex
    transition-property: transform
    transition-duration: .6s
    @screen lg
      transition-duration: .8s
    @screen xxl
      transition-duration: 1s
    will-change: transform
    @for $i from 2 through 6
      &--#{$i}
        transform: translateX(-100vw * ($i - 1))

  .control
    @apply fixed z-10 flex items-center text-3xl w-16 h-16
    top: 50%
    transform: translate(0, -50%)
    transition: transform .6s cubic-bezier(.07,.84,.64,1.01)
    background: rgba(0, 0, 0, 0.1)
    @screen lg
      @apply text-5xl w-24 h-24
    &__icon
      @apply inline-flex items-center h-full w-full
    &--previous
      @apply pin-l
      .control__icon
        @apply justify-end
        i
          @apply mr-2
    &--next
      @apply pin-r
      .control__icon
        i
          @apply ml-2
    &--previous-hidden
      transform: translate(-100%, -50%)
    &--next-hidden
      transform: translate(100%, -50%)

  .menu-btn
    @apply fixed z-10 inline-flex flex-col justify-between
    top: 20px
    right: 20px
    div
      @apply bg-black w-10 h-1
      &:nth-child(1)
        transition: transform .5s
      &:nth-child(2)
        @apply my-1
        transition: transform .5s .2s
      &:nth-child(3)
        transition: transform .5s .3s
    &--dismissed
      div
        transform: translateX(80px)

  .logo-ctn
    @apply relative z-10 inline-flex items-center justify-center w-full h-full
    img
      @apply w-auto h-full p-2

  .dry-signals-ctn
    background-image: url("~@/assets/dry-signals.jpg")

  .onesti-logo-ctn
    background: #d8306a

  .paguru-logo-ctn
    @apply bg-white
    img
      @apply px-3

  .lenossa-logo-ctn
    background: #009CB0

  .victor-linard-logo-ctn
    background : linear-gradient(90deg, rgba(35, 110, 170, 1) 0%, rgba(35, 107, 165, 1) 27.54%, rgba(36, 100, 152, 1) 58.66%, rgba(38, 88, 129, 1) 91.42%, rgba(38, 84, 122, 1) 100%);

  .dnare-logo-ctn
    @apply inline-flex items-center justify-center w-full h-full px-3
    background : linear-gradient(120.06deg, rgba(236, 179, 72, 1) 0%, rgba(234, 142, 68, 1) 100%)

  .contact-btn-ctn
    @apply fixed z-50 pin-t pin-l flex justify-end w-full pt-1 pr-1
    @screen xl
      @apply pt-2 pr-2

  .contact-btn
    @apply inline-block text-lg text-white font-sans bg-black px-2 py-1
    @screen lg
      @apply text-2xl
    @screen xl
      @apply text-3xl
  /* purgecss end ignore */
</style>
